// extracted by mini-css-extract-plugin
module.exports = {"block":"quote-slider_block__EMKVI","arrow":"quote-slider_arrow__G3VWb"};